import { connect } from 'react-redux';

import ArrhythmiaHistoryTable from 'components/ArrhythmiaHistoryTable';

import {
  getCardiacRisksActive,
  getEfValue,
  getEfDate,
  getEfMethod,
  getNyhaClassDisplay,
  getPacemakerDependent,
  getPriorVentricularArrhythmiaRecent,
  getIndicationForImplant,
  getTreatmentType,
  getIsAntiarrhythmicMedication,
  getAntiarrhythmicMedication,
  getIsCatheter,
  getIsAntiarrhythmicMedsDiscontinued,
} from 'store/selectors/questionnaireResponses';
import { getPatientPageUrlParams } from 'store/selectors/router';

import i18n from 'services/i18n';

import { getPatientDeviceType } from 'store/selectors/patientsData';
import {
  getFormattedPriorArtialArrhythmia,
  getFormattedCardiacRiskFactors,
  getFormattedEjectionFraction,
  getPriorVentricularArrhythmia,
  getPriorCurrentTreatment,
} from './formatters';

const mapStateToProps = state => {
  const { patientId } = getPatientPageUrlParams(state);

  return {
    data: [
      {
        title: i18n.t('reports.deviceType'),
        value: getPatientDeviceType(patientId)(state),
      },
      {
        title: i18n.t('reports.pacemakerDependent'),
        value: getPacemakerDependent(patientId)(state),
      },
      {
        title: i18n.t('reports.indicationForImplant'),
        value: getIndicationForImplant(patientId)(state),
      },
      {
        title: i18n.t('reports.priorVentricularArrhythmia'),
        value: getPriorVentricularArrhythmia(state, patientId),
      },
      {
        title: i18n.t('reports.priorTreatmentDetection'),
        value: getPriorVentricularArrhythmiaRecent(patientId)(state),
      },
      {
        title: i18n.t('reports.treatmentDetectionByDevice'),
        value: getTreatmentType(patientId)(state),
      },
      {
        title: i18n.t('reports.priorOrCurrentTreatmentForVentricularArrhythmia'),
        value: getPriorCurrentTreatment(state, patientId),
      },
      {
        title: i18n.t('reports.isThePatientOnAntiArrhythmiaMed'),
        value: `${getIsAntiarrhythmicMedication(patientId)(state)}; 
        ${getAntiarrhythmicMedication(patientId)(state)}`,
      },
      {
        title: i18n.t('reports.wereAnyAntiArrhythmicMedsDiscontinued'),
        value: getIsAntiarrhythmicMedsDiscontinued(patientId)(state),
      },
      {
        title: i18n.t('reports.priorVTCatheterAblationCompleted'),
        value: getIsCatheter(patientId)(state),
      },
      {
        title: i18n.t('reports.priorArtialArrhythmia'),
        value: getFormattedPriorArtialArrhythmia(state, patientId),
      },
      {
        title: i18n.t('reports.nyhaClass'),
        value: getNyhaClassDisplay(patientId)(state),
      },
      {
        title: i18n.t('reports.cardiacRiskFactors'),
        value: getFormattedCardiacRiskFactors(getCardiacRisksActive(patientId)(state)),
      },
      {
        title: i18n.t('reports.ejectionFractionMostRecent'),
        value: getFormattedEjectionFraction({
          value: getEfValue(patientId)(state),
          date: getEfDate(patientId)(state),
          method: getEfMethod(patientId)(state),
        }),
      },
    ],
  };
};

export default connect(mapStateToProps)(ArrhythmiaHistoryTable);
